var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.75C14.4832 8.75 14.875 8.35825 14.875 7.875C14.875 7.39175 14.4832 7 14 7C13.5168 7 13.125 7.39175 13.125 7.875C13.125 8.35825 13.5168 8.75 14 8.75Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.625L8.75 7.875L11.8125 10.5L10.5 12.25",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 14.6563C2.89738 14.7917 3.19593 14.8663 3.5 14.875C3.84081 14.8821 4.17823 14.8062 4.48313 14.6538C4.78802 14.5013 5.05123 14.2769 5.25 14C5.44877 13.7231 5.71198 13.4987 6.01687 13.3462C6.32177 13.1938 6.65919 13.1179 7 13.125C7.34081 13.1179 7.67823 13.1938 7.98313 13.3462C8.28802 13.4987 8.55123 13.7231 8.75 14C8.94877 14.2769 9.21198 14.5013 9.51687 14.6538C9.82177 14.8062 10.1592 14.8821 10.5 14.875C10.8408 14.8821 11.1782 14.8062 11.4831 14.6538C11.788 14.5013 12.0512 14.2769 12.25 14C12.4488 13.7231 12.712 13.4987 13.0169 13.3462C13.3218 13.1938 13.6592 13.1179 14 13.125C14.3408 13.1179 14.6782 13.1938 14.9831 13.3462C15.288 13.4987 15.5512 13.7231 15.75 14C15.9488 14.2769 16.212 14.5013 16.5169 14.6538C16.8218 14.8062 17.1592 14.8821 17.5 14.875C17.8041 14.8663 18.1026 14.7917 18.375 14.6563",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwim);
export default __webpack_public_path__ + "static/media/swim.62b3d993eebe376ca73ff82b9b62f347.svg";
export { ForwardRef as ReactComponent };